import { SvgIconProps } from '@traba/types'

export default function ThumbsDownFilled({
  color = '#7A8A99',
  size = 24,
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50706 9.8057L3.14049 6.35478C3.04767 6.12037 3 5.87053 3 5.61842L3 3.5C3 2.39543 3.89543 1.5 5 1.5L8.31891 1.5C9.18198 1.5 9.9477 2.05365 10.2182 2.87324L10.4093 3.45246C10.8234 4.70739 9.88883 6 8.56733 6C7.49607 6 6.62764 6.86843 6.62764 7.93969L6.62764 9.40111C6.62764 10.008 6.13565 10.5 5.52875 10.5C5.07803 10.5 4.67301 10.2248 4.50706 9.8057Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
      <path
        d="M1.5 2.25V5.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
